import Lottie from 'lottie-react';

import loader from '../../../../../../../assets/grey-loader.json';

import { StyledOverlay } from '../../../../ScreenLock/style';

interface AdyenApmScreenLockProps {
  text: string;
}

export function AdyenApmScreenLock({ text }: AdyenApmScreenLockProps) {
  return (
    <StyledOverlay>
      <p>{text}</p>
      <Lottie animationData={loader} style={{ height: 75 }} />
    </StyledOverlay>
  );
}
